import * as yup from 'yup';

const SensitiveInfoSchema = yup.object({
    bank_transaction_code: yup.object().required('Bank transaction code is a required field').typeError('Bank transaction code is a required field'),
});

export default SensitiveInfoSchema;
